import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TableCellParams, TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { getOtmData } from '../../../../redux-store/actions/newPurchase';
import ActionHeader from '../../../common/ActionHeader';
import NoFoliosFound from '../../makeNct/NoFoliosFound';
import en from '../../../../lang/en-us';
import { IconButton } from '@material-ui/core';
import { SubmitButton } from '../../../../lib/Button';
import { useHistory } from 'react-router';
import { CommercialRootPath } from '../routeConfig';
import { EMandatePaths } from './types';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { formatAsIndianCurrency } from '../../../../utils/currency';
import { IsAllow } from '../../../../redux-store/types/portfolio';
import { OTMCancelButton } from './OTMCancelButton';
import { rtaNames } from '../../../common/FatcaCheck.types';

const { dbCommercial } = en;

const shouldShowCancelButton = (row: any) => {
    return (
        // row.rtaName === rtaNames.CAMS &&
        row?.otmCancelAllowed === IsAllow.YES &&
        row.status.toLowerCase() === 'active'
    );
};

const _renderOtmData = ({ row, setCollapse, collapse }: TableCellParams) => {
    return (
        <>
            <IconButton
                className="update-nominee-collapse-btn"
                aria-label="expand row"
                size="small"
                onClick={(e) => {
                    e.stopPropagation();
                    setCollapse((open: boolean) => !open);
                }}
            >
                {!collapse ? (
                    <>
                        <span>View</span>
                        <KeyboardArrowDown />
                    </>
                ) : (
                    <>
                        <span>Hide</span>
                        <KeyboardArrowUp />
                    </>
                )}
            </IconButton>
        </>
    );
};

const showCollapseData = ({ row }: TableCellParams) => {
    const values: { label: string; value: string }[] = [
        {
            label: 'Bank Name',
            value: row.bank?.name,
        },
        {
            label: 'Account No.',
            value: row.bank?.accountNo,
        },
        {
            label: 'Ifsc',
            value: row.bank?.ifsc,
        },
        {
            label: 'OTM Type',
            value: row.otmType,
        },
        ...(row.status?.toUpperCase() !== 'ACTIVE'
            ? [
                  {
                      label: 'Remarks',
                      value: row.remarks,
                  },
              ]
            : []),
        ...(row.otmType === 'AMCOTM'
            ? [
                  {
                      label: 'Folio',
                      value: row.folio,
                  },
                  {
                      label: 'Fund house',
                      value: row.otmAmcName,
                  },
              ]
            : []),
        {
            label: 'Cancel',
            value: 'button',
        },
    ];
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                width: '100%',
                flexWrap: 'wrap',
            }}
        >
            {values.map(({ label, value }, index) => (
                <div
                    key={index}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginRight: 0,
                        width: '32%',
                        padding: '10px',
                    }}
                >
                    {value === 'button' ? (
                        shouldShowCancelButton(row) && <OTMCancelButton row={row} />
                    ) : (
                        <>
                            <label>{label}</label>
                            <label>{value ? value : 'N/A'}</label>
                        </>
                    )}
                </div>
            ))}
        </div>
    );
};
const OtmDataColumns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'UMRN Number',
        fullWidth: true,
        valueGetter: ({ row }) => `${row.omUMRN}`,
        width: 250,
    },
    // { field: 'rtaCode', headerName: 'RTA Code', width: 120 },
    {
        field: 'maxAmount',
        headerName: 'Max Amount',
        valueGetter: ({ value }) => formatAsIndianCurrency(Number(value)),
        width: 100,
    },
    { field: 'omExpiryDate', headerName: 'Expiry Date', width: 120 },
    {
        field: 'status',
        headerName: 'Status',
        width: 120,
        filterBy: true,
        filterKey: 'status',
        filterHeader: 'Status',
    },

    {
        field: 'otm',
        renderCell: _renderOtmData,
        headerName: '',
        width: 100,
    },
];

const OtmRegistrationTable = () => {
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { selectedRows, setSelectedRows, resetTable, tableColumns, tableRows, ...filters } =
        useTableWithCollapse<any[]>({
            initialSelectionModal: [],
            rows: data,
            columns: OtmDataColumns,
            loading: loading,
        });

    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        async function fetchOtm() {
            const payload: any = {
                amc: '',
            };
            try {
                setLoading(true);
                const response = await dispatch(getOtmData(payload));
                if (!!response && typeof response === 'object') {
                    const { body = {} }: any = response;
                    setData([
                        ...(body.data || []).map((ele: any) => ({
                            ...ele,
                            id: ele.omUMRN,
                        })),
                    ]);
                }
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        fetchOtm();
    }, []);
    return (
        <div className="curved-bg mf-investment mf-payment payment-screen">
            <ActionHeader header={dbCommercial.exploreMfs.eMandate.registerMandate} />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    margin: 10,
                    marginTop: '-20px',
                }}
            >
                <SubmitButton
                    onClick={() =>
                        history.push(`${CommercialRootPath}${EMandatePaths.OtmRegister}`)
                    }
                    fullWidth={false}
                    label="+ New OTM Registration"
                ></SubmitButton>
            </div>
            <div className="curved-bg-content curved-bg-table-outer">
                {/* <div className="mf-investment-left" style={{ maxWidth: 'unset' }}> */}
                <div className="curved-bg-content-table" style={{ width: '100%' }}>
                    {!!loading || tableRows.length ? (
                        <TableWithCollapse
                            rows={tableRows}
                            columns={tableColumns}
                            selectedRows={selectedRows}
                            setSelectedRows={setSelectedRows}
                            renderCollapse={showCollapseData}
                            enableSearch={false}
                            {...filters}
                        />
                    ) : (
                        <NoFoliosFound info={`No OTM's found for this pan`} />
                    )}
                </div>
                {/* </div> */}
            </div>
        </div>
    );
};

export default OtmRegistrationTable;
